import type { ReactNode } from 'react'

import {
  comicEpisodeCanvasContentTrackClass,
  comicEpisodeCanvasSectionClass,
  comicEpisodeCanvasSectionZIndex,
  comicEpisodeCanvasStickyHeaderClass,
} from '../../lib/comicCanvasChrome'

type Props = {
  episodeId: string
  episodeIndex: number
  angular: boolean
  header: ReactNode
  children: ReactNode
}

/**
 * 画布滚动轨道中的单话区块：标题在块顶缘吸顶，分页内容在其下滚动离开。
 */
export function ComicEpisodeCanvasEpisodeSection({
  episodeId,
  episodeIndex,
  angular,
  header,
  children,
}: Props) {
  return (
    <section
      className={comicEpisodeCanvasSectionClass()}
      style={{ zIndex: comicEpisodeCanvasSectionZIndex(episodeIndex) }}
      data-comic-episode-canvas-section={episodeId}
      aria-labelledby={`comic-canvas-episode-heading-${episodeId}`}
    >
      <header className={comicEpisodeCanvasStickyHeaderClass(angular)}>{header}</header>
      <div className={comicEpisodeCanvasContentTrackClass()}>{children}</div>
    </section>
  )
}
